import React from 'react';
import {AlertBanner} from '@resurs-internal/mui';
import {useBanner} from '../../hooks';

export const LoginBanner = () => {
  const {banner, show, dismiss} = useBanner();
  if (!show) return null;

  return (
    <AlertBanner
      severity={banner?.variant}
      title={banner?.title}
      subtitle={banner?.text}
      onClose={dismiss}
      sx={{borderRadius: 0}}
    />
  );
};
